import Web3 from "web3";
import { AbiItem } from "web3-utils";
import WienerNFT from "contracts/wienerABI.json";

const contractAddress = "0x69D1eF5E955940218c2d77Ac9a3fB61ab0c9f48e";
const wienerWeb3 = new Web3(Web3.givenProvider);

const wienerNFT = new wienerWeb3.eth.Contract(
  WienerNFT as AbiItem[],
  contractAddress
);

export { wienerNFT, wienerWeb3 };
